import React from "react";

import { list } from "../../services/api/Track";
import { TrackWithDetails } from "../../common/apiTypes";
import { DocumentSearchPage } from "../../components/DocumentSearchPage";
import { TracksTable } from "../../components/TracksTable";

export class TracksPage extends React.Component {
  public render() {
    return (
      <DocumentSearchPage
        typeName="Track"
        placeholder="Track or Organization ID, User Slack ID or Name"
        load={list}
        renderTable={(tracks: TrackWithDetails[]) => (
          <TracksTable tracks={tracks} />
        )}
      />
    );
  }
}
